import React from "react";
import "./styles/ButtonYesProfileDelete.css";

function ButtonYesProfileDelete() {
  return (
    <div className="containbuttonyesprofiledelete">
      <button
        type="submit"
        className="buttonyesprofiledelete"
        style={{ cursor: "pointer" }}
      >
        <h3>Oui, je supprime le profil de l'utilisateur</h3>
      </button>
    </div>
  );
}

export default ButtonYesProfileDelete;
